import { ProcedimentoSelectModel } from 'components/form/field/select/ProcedimentoSelectField'
import { AtendimentoIndividualViewQuery, TipoAtendimentoEnum } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'
import { v4 as uuidv4 } from 'uuid'

import { MedicamentoInterromperFormModel } from '../detail/components/modals/medicamentos/InterromperTratamentoModal'
import { MedicaoAnteriorFormModel } from '../detail/components/modals/medicoes/MedicaoAnteriorForm'
import { AvaliacaoFormModel } from '../detail/soap/avaliacao/AvaliacaoForm'
import { DesfechoFormModel } from '../detail/soap/desfecho'
import { ManterCidadaoLista } from '../detail/soap/desfecho/components/DesfechoAtendimentoPanel'
import { ObjetivoFormModel } from '../detail/soap/objetivo'
import { PlanoFormModel } from '../detail/soap/plano/PlanoForm'
import { SubjetivoFormModel } from '../detail/soap/subjetivo'
import { AgendamentoDia } from '../types/AgendamentoDia'

export type TipoServicoSoapView = AtendimentoIndividualViewQuery['atendimento']['tiposServico'][number]

export interface SoapState {
  openedAccordions?: (string | number)[]
  subjetivo?: SubjetivoFormModel
  objetivo?: ObjetivoFormModel
  avaliacao?: AvaliacaoFormModel
  plano?: PlanoFormModel
  desfecho?: DesfechoFormModel
  imprimirAtendimento?: boolean
  lastSaved?: Date
  medicoesAnteriores?: MedicaoAnteriorFormModel[]
  medicamentosInterromper?: MedicamentoInterromperFormModel[]
}

export const meta = metaPath<SoapState>()

export const initialValue = (
  procedimentoAdministrativo: ProcedimentoSelectModel,
  isDemandaEspontanea: boolean,
  agendamentosDia: AgendamentoDia[],
  tiposServico: TipoServicoSoapView[],
  canCreateNovoAtendimento: boolean
): Partial<SoapState> => ({
  openedAccordions: ['S', 'O', 'A', 'P', 'D'],
  lastSaved: new Date(),
  objetivo: {
    medicoes: {
      openedAccordions: [],
    },
  },
  desfecho: {
    tipoAtendimento: isDemandaEspontanea ? TipoAtendimentoEnum.CONSULTA_NO_DIA : TipoAtendimentoEnum.CONSULTA,
    procedimentosAdministrativos: procedimentoAdministrativo && [
      { _id: uuidv4(), procedimento: procedimentoAdministrativo, automatico: true },
    ],
    desfechoAtendimento: {
      manterCidadaoLista:
        (agendamentosDia?.length || tiposServico?.length) && canCreateNovoAtendimento
          ? ManterCidadaoLista.SIM
          : ManterCidadaoLista.NAO,
      novoAtendimento: {
        tiposServico: tiposServico?.map((t) => t.id),
      },
    },
  },
  medicoesAnteriores: [],
})
